<template>
  <div class="home-container">
    <div class="welcome-section">
      <div class="welcome-content">
        <div class="welcome-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
            <polyline points="9,22 9,12 15,12 15,22"/>
          </svg>
        </div>
        <h1>Üdvözöljük!</h1>
        <p v-if="isAdmin || isTeacher">Admin felület - Csoportok és események kezelése</p>
        <p v-else-if="isDancer">Saját foglalkozások és versenyek</p>
        <p v-else>Gyermekek és foglalkozások kezelése</p>
        <div v-if="isAdmin || isTeacher" class="stat-pill">Diák száma: <strong>{{ studentCount }}</strong></div>
      </div>
    </div>
    
    <div class="content-section">
      <div v-if="isAdmin || isTeacher" class="admin-content">
        <GroupsWithDate />
        <div v-if="upcomingCompetitions.length" class="competitions-section">
          <h2>Közelgő versenyek</h2>
          <div class="competition-list">
            <div v-for="comp in upcomingCompetitions" :key="comp.id" class="competition-card">
              <div class="comp-date">{{ comp.comp_date }}</div>
              <div class="comp-title">{{ comp.title }}</div>
              <div v-if="comp.location" class="comp-location">{{ comp.location }}</div>
            </div>
          </div>
        </div>
      </div> 
      <div v-else class="user-content">
        <MultipleChildItem />
      </div>
    </div>
  </div>
</template>

<script>
import GroupsWithDate from './GroupsWithDate.vue';
import MultipleChildItem from './MultipleChildItem.vue';

export default {
  components: {
    GroupsWithDate,
    MultipleChildItem
  },
  data() {
    return {
      isAdmin: false,
      isTeacher: false,
      isAssistant: false,
      isDancer: false,
      studentCount: 0,
      upcomingCompetitions: [],
    };
  },
  methods: {
    getIsAdmin() {
      this.isAdmin = this.$isAdmin();
    },
    getIsTeacher() {
      this.isTeacher = this.$isTeacher();
    },
    getIsDancer() {
      this.isDancer = this.$isDancer();
    },
    async fetchStudentCount() {
      try {
        const r = await fetch(this.$BACKEND_HOST + '/api/dashboard/student-count');
        const d = await r.json();
        this.studentCount = d.student_count || 0;
      } catch (e) { console.error(e); }
    },
    async fetchCompetitions() {
      try {
        const r = await fetch(this.$BACKEND_HOST + '/api/competitions/home');
        const d = await r.json();
        this.upcomingCompetitions = d.events || [];
      } catch (e) { console.error(e); }
    },
  },
  mounted() {
    this.getIsAdmin();
    this.getIsTeacher();
    this.getIsDancer();
    this.fetchStudentCount();
    this.fetchCompetitions();
  }
};
</script>

<style scoped>
.home-container {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.welcome-section {
  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
  border-radius: 16px;
  padding: 2rem;
  color: white;
  text-align: center;
  box-shadow: var(--shadow-lg);
  position: relative;
  overflow: hidden;
}

.welcome-section::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}

.welcome-content {
  position: relative;
  z-index: 1;
}

.welcome-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  margin-bottom: 1rem;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.welcome-content h1 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.welcome-content p {
  font-size: 1.125rem;
  opacity: 0.9;
  margin: 0;
  font-weight: 500;
}

.content-section {
  flex: 1;
}

.admin-content,
.user-content {
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: var(--shadow);
  border: 1px solid var(--color-border);
  overflow: hidden;
}

.competitions-section {
  padding: 1.5rem;
  border-top: 1px solid var(--color-border);
}

.lessons-section {
  padding: 1.5rem;
  border-top: 1px solid var(--color-border);
}

.lessons-section h2 {
  font-size: 1.25rem;
  margin: 0 0 1rem 0;
  color: var(--color-text);
}

.lesson-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.lesson-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1rem;
  background: var(--color-background-soft);
  border-radius: 10px;
  border: 1px solid var(--color-border);
}

.lesson-card__name {
  font-weight: 600;
  color: var(--color-text);
  flex: 1;
}

.lesson-card__details {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
}

.lesson-card__date {
  font-weight: 700;
  color: var(--primary-blue);
  white-space: nowrap;
  font-size: 0.9rem;
}

.lesson-card__schedule {
  color: var(--color-text-muted);
  font-size: 0.85rem;
}

.competitions-section h2 {
  font-size: 1.25rem;
  margin: 0 0 1rem 0;
  color: var(--color-text);
}

.competition-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.competition-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1rem;
  background: var(--color-background-soft);
  border-radius: 10px;
  border: 1px solid var(--color-border);
}

.comp-date {
  font-weight: 700;
  color: var(--primary-blue);
  white-space: nowrap;
}

.comp-title {
  font-weight: 600;
  color: var(--color-text);
}

.comp-location {
  color: var(--color-text-muted);
  font-size: 0.9rem;
}

.stat-pill {
  margin-top: 1rem;
  display: inline-block;
  background: rgba(255,255,255,0.18);
  padding: 0.4rem 1rem;
  border-radius: 999px;
  font-size: 1rem;
}

@media (max-width: 768px) {
  .home-container {
    gap: 1.5rem;
  }
  
  .welcome-section {
    padding: 1.5rem;
    border-radius: 12px;
  }
  
  .welcome-icon {
    width: 64px;
    height: 64px;
  }
  
  .welcome-content h1 {
    font-size: 2rem;
  }
  
  .welcome-content p {
    font-size: 1rem;
  }
  
  .admin-content,
  .user-content {
    border-radius: 12px;
  }
}

@media (max-width: 480px) {
  .welcome-section {
    padding: 1.25rem;
    border-radius: 10px;
  }
  
  .welcome-icon {
    width: 56px;
    height: 56px;
  }
  
  .welcome-content h1 {
    font-size: 1.75rem;
  }
  
  .welcome-content p {
    font-size: 0.9rem;
  }
}
</style>
